import { render, staticRenderFns } from "./Stocks_Insuficientes_Compra_Orden_Produccion.vue?vue&type=template&id=08cc0803&scoped=true"
import script from "./Stocks_Insuficientes_Compra_Orden_Produccion.vue?vue&type=script&lang=js"
export * from "./Stocks_Insuficientes_Compra_Orden_Produccion.vue?vue&type=script&lang=js"
import style0 from "./Stocks_Insuficientes_Compra_Orden_Produccion.vue?vue&type=style&index=0&id=08cc0803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc0803",
  null
  
)

export default component.exports